import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles';

const CheckIcon = props => {
  const { checked, partial, height, left, top, strokeWidth, styling } = props;

  return (
    <svg
      className={styles.check.withModifier({
        [styling]: true,
      })}
      height={height}
      width={height}
      viewBox="0 0 34 34"
      fill="none"
      strokeLinecap="miter"
      strokeLinejoin="butt"
      strokeWidth={strokeWidth}
      stroke="currentcolor"
      style={{
        left,
        top,
      }}
    >
      {checked && <path d="M3 16 L14 24 26 4" />}
      {partial && <path d="M4 16 L24 16" />}
    </svg>
  );
};

const { number, bool, oneOf, string } = PropTypes;
CheckIcon.propTypes = {
  height: number,
  checked: bool,
  partial: bool,
  top: number,
  left: number,
  strokeWidth: string,
  styling: oneOf([
    'primary',
    'secondary',
    'call-to-action',
    'light',
    'icon',
    'neutral',
    'neutral-light',
  ]),
};

CheckIcon.defaultProps = {
  height: 8,
  checked: false,
  partial: false,
  top: 0,
  left: 0,
  strokeWidth: '4',
  styling: 'primary',
};

export default CheckIcon;
